import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { quaddieMarket } from "@/types/api/firestore/generated.zod";
import { where } from "firebase/firestore";
import type { Always, Nullable } from "@/types/utilities";
import { useMemo } from "react";

const useQuaddieMarkets = (
  meetingIds: Nullable<string[]>,
  activeOnly = true,
) => {
  const { data, isLoading, error } = useFirestore(
    meetingIds ? `/quaddieMarkets` : null,
    quaddieMarket.array(),
    {
      keyPath: "id",
      query: [where("meetingIds", "array-contains-any", meetingIds)],
    },
  );

  const filteredMarkets = useMemo(() => {
    if (!data) return;

    if (!activeOnly) return data;

    return data.filter((market) => market.status === "ACTIVE");
  }, [data, activeOnly]);

  return {
    markets: filteredMarkets,
    isLoading,
    error,
  };
};

const useQuaddieMarket = (marketId: string) => {
  const { data, isLoading, error } = useFirestore(
    marketId && `/quaddieMarkets/${marketId}`,
    quaddieMarket,
  );

  return {
    market: data,
    isLoading,
    error,
  };
};

type QuaddieMarket = Always<ReturnType<typeof useQuaddieMarkets>["markets"]>[0];
export type { QuaddieMarket };
export { useQuaddieMarkets, useQuaddieMarket };
